import React, { useRef } from 'react'
import Modal from 'jd-library/Modal'
import Button from 'jd-library/Button'
import ImageViewUpload from '../../common/product-image/ImageViewUpload'
import './photo-modals.scss'
import { getImagePath, updateProductMediaService } from '../../common/productImageUtils'
import historyHandler from 'jd-library/historyHandler'
import { useDispatch } from 'react-redux'
import { getListingData, getVendorProducts, uploadAddEditMutlipleImages } from '../../actions/products'
import ScrollIndicators from '../../common/ViewImage/ScrollIndicators'
import { useHistory } from 'react-router-dom'
import { toggleUploadOptions, uploadImageFromLink } from '../../actions/upload-options'
import { useSelector } from 'react-redux'
import { showHideLoader } from '../../actions'

export const DeletePhotosModal = ({
	onHidden,
	selectedImages,
	deletePhotos,
	isMobile
}) => {
	const photoStr = selectedImages.length > 1 ? 'Photos' : 'Photo';
	return (
		<Modal
			settings={{
				modalId: 'basic-modal',
				class: 'photo-modal '+(isMobile ? '' : 'web-modal'),
				variant: 'action'
			}}
			onHidden={onHidden}
		>
			<Modal.CloseIcon />
			<Modal.Header className='delete-modal-header'>Delete {photoStr}</Modal.Header>
			<Modal.Body>
				<div className="delete-modal-body" >
					<div className="modal-text">{`Are you sure you want to delete ${selectedImages.length > 1 ? selectedImages.length+' photos?' : 'this photo?'}`}</div>
					<Button
						block={true}
						onClick={deletePhotos}
						size='lg'
						variant='danger'
					>
						Delete {photoStr}
					</Button>
				</div>
			</Modal.Body>
		</Modal>
	)
}

export const AddProductModal = ({
	onHidden,
	imageArr,
	addToExisting,
	createNew,
	mode,
	redirectedFrom,
	productData,
	deletePhotos,
	payload,
	isMobile,
	showToast,
	isJdPhotoSlider,
	profileObject,
	tabKey,
	supplierId,
	clickTrack,
	viaOmni
}) => {
	const photoStr = imageArr.length > 1 ? 'Photos' : 'Photo';
	const labelText = profileObject.SingleLabelWithSpace;
	const dispatch = useDispatch();
	const history = useHistory();
	const thumbnailHolder = useRef();
	const allProducts = useSelector(state => state.products.allProducts);
	const session = useSelector(state => state.session);
	const addPhotosToProduct = () => {
		let finalImageUrl = imageArr.filter((cur) => {
			return cur.uploaded
		})
		finalImageUrl = finalImageUrl.map(obj => obj.imageUrl);
		let combinedUrl = '';
		if(productData.imageUrl){
			combinedUrl = productData.imageUrl + "," + finalImageUrl.join(",");
		}else{	
			combinedUrl = finalImageUrl.join(",");
		}
		if(combinedUrl.split(",").length > 40){
			showToast({
				showToastMessage: true,
				message: `Max 40 Images are Allowed in One ${labelText}. Please Unselect Few Photos before Combining them into a Single ${labelText}`,
				duration: 5000,
				className: !isMobile ? 'large-toast' : '',
				longToastMessage: true,
				type:'error',
				bottom: session.hasGlassFooter ? '80px' : '0px'
			})
			historyHandler.closeCurrent();
			return;
		}
		if(productData.generic_p_id){
			createNew(productData);
			return;
		}
		const remainingImages = deletePhotos();
		const callbackFn = () => {
			showToast({
				showToastMessage: true,
				message: `${imageArr.length > 1 ? 'Photos' : 'Photo'} Added to ${productData.type == 'product' ? 'Product': 'Service'} Successfully`,
				duration: 5000,
				bottom: session.hasGlassFooter ? '80px' : '0px'
			})
			const imageUrlArr = combinedUrl.split(",").map((cur) => {
				return {
					imgURL: cur,
					actualPath: getImagePath(cur),
					uploaded: true
				}
			})
			dispatch(uploadAddEditMutlipleImages({
				productId: productData.productId,
				imageUrlArr
			}))
			if (payload.source == 'webstore') {
				// refetch data here
				setTimeout(() => {
					dispatch(getVendorProducts({}));
				}, 1000);
			} else {
				setTimeout(() => {
					dispatch(getListingData({tabKey,supplierId}));
				}, 1000)
			}
		};


		if(isJdPhotoSlider) {
			dispatch(toggleUploadOptions({
				show: false,
				data: {
					productId: productData.productId
				}
			}))
			dispatch(showHideLoader({
				showLoader: true
			}))
			const uploadPromises = finalImageUrl
				.filter(curLink => curLink.includes('content.jdmagicbox'))
				.map(curLink =>
				new Promise(resolve => {
					dispatch(uploadImageFromLink({
					link: curLink
					}, isSuccess => resolve(isSuccess)));
				})
			);
			Promise.all(uploadPromises).then(results => {
				allProducts[productData.productId].imageUrlArr.forEach(cur => {
					combinedUrl += cur.imgURL + ',';
				});
				combinedUrl = combinedUrl.substring(0, combinedUrl.length - 1);
				callbackFn();
				dispatch(showHideLoader({
					showLoader: false
				}))
			})
		}else {
			updateProductMediaService({
				productId: productData.productId,
				imageUrl: combinedUrl,
				token: payload.token,
				source: payload.source
			}).then(() => callbackFn())
		}
		if(isMobile){
			historyHandler.closeAll();
			if(typeof remainingImages != 'undefined' && !remainingImages){
				history.goBack();
			} else if(isJdPhotoSlider) {
				// history.goBack();
			}
		}else{
			historyHandler.closeCurrent(); // close Modal
			if(redirectedFrom == 'searchProd'){
				historyHandler.closeCurrent(); // close Search Slider
			}
			historyHandler.closeCurrent();	// close Select Prod Slider
			if(typeof remainingImages != 'undefined' && !remainingImages) {
				setTimeout(()=>{
					historyHandler.closeCurrent(); // close all sliders
				},0)
			}
			if(isJdPhotoSlider){
				historyHandler.closeCurrent();
			}
		}
	}
	return (
		<Modal
			settings={{
				modalId: 'basic-modal',
				class: 'photo-modal '+(isMobile ? '' : 'web-modal'),
				modalInsideSlider: isMobile
			}}
			onHidden={onHidden}
		>
			<Modal.CloseIcon />
			<Modal.Header className='add-modal-header'>Add {photoStr} to {labelText}</Modal.Header>
			<Modal.Body>
				<div className="add-modal-body" >
					<div className="modal-text">
						{mode == 'confirmation' ? 'Are you sure you want to add following '+photoStr.toLowerCase()+' to '+(productData.productName)+'?' : 'Choose what you want to do with the following '+photoStr.toLowerCase()}
					</div>
					<div className="image-preview-wrapper">
						{!isMobile && <ScrollIndicators
							scrollContainerRef={thumbnailHolder}
							mediaLength={imageArr.length}
						/>}
						<div 
							ref={thumbnailHolder}
							className={`image-preview ${imageArr.length > 3 ? '' : 'justify-center'}`} body-scroll-lock-ignore='true'>
							{
								imageArr.map((item)=>{
									return(
										<ImageViewUpload 
											imageUrlArr={[item]}
											customCB={()=>{}}
										/>
									)
								})
							}
							{ imageArr.length > 3 ? <div className='right-spacing'></div> : null }
						</div>
					</div>
					{!(profileObject.isRE || profileObject.isSO) || viaOmni ? 
						null:
						<div className='info-text'>
							{`Would you like to create products automatically using AI from your uploaded ${imageArr.length > 1 ? 'photos' : 'photo'}?`}
							<Button
								block={true}
								onClick={()=>{
									clickTrack({li: 'ai_create_product_photos', ll: 'digital_catalog'});
									createNew('','product',true);
								}}
								size='lg'
								className='create-button ai-gradient-button'
							>
								Create New Product using AI<span>✧</span>
							</Button>
						</div>}
					<div className='modal-buttons'>
						{mode == 'confirmation' ? 
							<Button
								block={true}
								onClick={addPhotosToProduct}
								size='lg'
							>
								Yes, Add {photoStr}
							</Button>
							: <>	
								{!(profileObject.isRE || profileObject.isSO) || !viaOmni ? 
									null:
									<Button
										block={true}
										onClick={()=>createNew('','product')}
										size='lg'
										className='create-button'
									>
										Create New Product
									</Button>
								}
								{profileObject.isSer ? <Button
									block={true}
									onClick={()=>{
										clickTrack({li: 'create_service_photos', ll: 'digital_catalog'});
										createNew('','service');
									}}
									size='lg'
									className='create-button'
								>
									Create New Service
								</Button> : null}
								<Button
									block={true}
									onClick={() => {
										clickTrack({li: 'update_existing_productandservice_photos', ll: 'digital_catalog'});
										addToExisting();
									}}
									size='lg'
									className={isMobile?'exist-button-mob':''}
								>
									Add {photoStr} to Existing {profileObject.SingleLabelWithSpace}
								</Button>
							</>}
						</div>
				</div>
			</Modal.Body>
		</Modal>
	)
}